import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import Calendar from '../../commons/Calendar/Calendar';
import Scheduler from '../../commons/Calendar/Scheduler';
import Appointment from '../../components/home/Appointments';
import { BootstrapSelect } from '../../commons/Inputs';
import FABMultitple from '../../commons/Buttons/FABMultiple';
import AppointmentModal from '../../components/home/AppointmentModal';
import moment from 'moment';

import {
    selectedADate,
    getAppointmentsApi,
    postAppointmentApi,
    putAppointmentApi,
    viewAppointment,
    newAppointment,
    putAppointmentSuccess
} from '../../actions/appointments';

import {
    getProceduresApi
} from '../../actions/procedures';

import {
    getBranchesApi
} from '../../actions/branches';

import {
    getPractitionersApi
} from '../../actions/practitioners';

let App = window.App;

class Home extends Component {
    static propTypes = {
        selectedADate: PropTypes.func.isRequired,
        getAppointmentsApi: PropTypes.func.isRequired,
        getBranchesApi: PropTypes.func.isRequired,
        getProceduresApi: PropTypes.func.isRequired,
        getPractitionersApi: PropTypes.func.isRequired,
        postAppointmentApi: PropTypes.func.isRequired,
        putAppointmentApi: PropTypes.func.isRequired,
        putAppointmentSuccess: PropTypes.func.isRequired,
        viewAppointment: PropTypes.func.isRequired,
        newAppointment: PropTypes.func.isRequired,
        branches: PropTypes.object.isRequired,
        practitioners: PropTypes.object.isRequired,
        procedures: PropTypes.object.isRequired
    };

    state = {
        dentists: [],
        branches: [],
        procedures: [],
        appointmentsForMonth: [],
        appointments: [],
        fabChildMenu: [
            {
                label: 'New Patient',
                icon: 'fa-patient',
                action: this.openNewAppointmentModal
            },
            {
                label: 'New Appointment',
                icon: 'fa-book',
                action: this.openNewPatientModal
            }
        ],
        dateFilter: 0,
        dateClicked: moment().format('YYYY-MM-DD'),
        dentistFilter: 0,
        branchFilter: 0,
        statusCompleted: 0,
        statusCancelled: 0,
        statusPending: 0,
        activeDisplay: 'list'
    };

    openNewAppointmentModal = () => {

    };

    openNewPatientModal = () => {

    };

    getAppointments = () => {
        App.blockUI({
            target: '#appointment_portlet',
            boxed: true
        });

        let appointments = [];
        let pending = 0;
        let completed = 0;
        let cancelled = 0;
        let rawAppointments = null;

        try {
            rawAppointments = this.props.appointments.getIn(['data', this.state.dateClicked]).toJSON();
        } catch (e) {
            App.unblockUI('#appointment_portlet');

            return {
                appointments,
                statusPending: pending,
                statusCompleted: completed,
                statusCancelled: cancelled
            };
        }


        if (typeof rawAppointments === 'undefined') {
            App.unblockUI('#appointment_portlet');

            return {
                appointments,
                statusPending: pending,
                statusCompleted: completed,
                statusCancelled: cancelled
            };
        }

        for (let appointment of rawAppointments) {
            // Filter Branch
            if (this.state.branchFilter > 0) {
                if (appointment.facility_id !== this.state.branchFilter) {
                    continue;
                }
            }

            // Filter Dentist
            if (this.state.dentistFilter > 0) {
                if (appointment.practitioner_id !== this.state.dentistFilter) {
                    continue;
                }
            }

            appointments.push(appointment);

            switch(appointment.status) {
                case 'pending':
                    pending += 1;
                    break;
                case 'completed':
                    completed += 1;
                    break;
                case 'cancelled':
                    cancelled += 1;
                    break;
                default:
                // Do nothing
            }
        }

        App.unblockUI('#appointment_portlet');

        return {
            appointments,
            statusPending: pending,
            statusCompleted: completed,
            statusCancelled: cancelled
        };
    };

    getAppointmentsForTheMonth = () => {

        let filter = null;
        if (this.state.dateFilter) {
            filter = `?date=${this.state.dateFilter}`;
        }

        //if (this.props.appointments.get('data').size <= 0) {
        this.props.getAppointmentsApi(filter);
        //}

        // axios.get(url).then((res) => {
        //     this.props.onGetAppointments(res.data.data);
        //
        //     App.unblockUI('#appointment_portlet');
        // }).catch((res) => {
        //     console.log(res);
        //     App.unblockUI('#appointment_portlet');
        // });
    };

    handleFilterBranch = (e) => {
        this.setState({
            branchFilter: parseInt(e.target.value, 10)
        }, () => {
            this.getAppointments();
        });
    };

    handleFilterDentist = (e) => {
        this.setState({
            dentistFilter: parseInt(e.target.value, 10)
        }, () => {
            this.getAppointments();
        });
    };

    handleCalendarDayClick = (date) => {

        this.setState({
            dateClicked: date
        }, () => {
            this.getAppointments();
        });
    };

    getProcedures = () => {
        if (this.props.procedures.get('data').size <= 0) {
            this.props.getProceduresApi();
        }
    };

    parseProcedures = (proceduresRaw) => {
        let procedures = [
            {
                value: 0,
                label: 'Select Procedure...'
            }
        ];

        proceduresRaw.forEach((item, i) => {
            let tmp = {
                value: item.id,
                label: item.procedure
            };

            procedures.push(tmp);
        });

        return procedures;
    };

    getBranches = () => {
        if (this.props.branches.get('data').size <= 0) {
            this.props.getBranchesApi();
        }
    };

    parseBranches = (branchesRaw) => {
        let branches = [
            {
                value: 0,
                label: 'Select Clinic Branch...'
            },
            {
                value: 0,
                label: 'View All'
            }
        ];

        branchesRaw.forEach((item, i) => {
            let tmp = {
                value: item.id,
                label: item.name
            };

            branches.push(tmp);
        });

        return branches;
    };

    getDentists = () => {
        if (this.props.practitioners.get('data').size <= 0) {
            this.props.getPractitionersApi();
        }
    };
    
    parseDentists = (dentistsRaw) => {
        let dentists = [
            {
                value: 0,
                label: 'Select Dentist...'
            },
            {
                value: 0,
                label: 'View All'
            }
        ];

        dentists = dentists.concat(dentistsRaw);

        return dentists;
    };

    handleChangeMonth = (date) => {
        this.setState({
            dateFilter: date,
            dateClicked: date
        }, () => {
            App.blockUI({
                target: '#appointment_portlet',
                boxed: true
            });

            this.getAppointmentsForTheMonth();
        });
    };

    handleChangeDisplayToCalendar = (e) => {
        this.setState({ activeDisplay: 'calendar' });
    };

    handleChangeDisplayToList = (e) => {
        this.setState({ activeDisplay: 'list' });
    };

    componentDidMount() {
        this.getProcedures();
        this.getBranches();
        this.getDentists();
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            appointmentsForMonth: nextProps.appointments.data
        }, () => {
            this.getAppointments();
        });
    }

    render() {
        const { branches, practitioners,
            appointments, session,
            procedures, showNotification,
            postAppointmentApi, putAppointmentApi,
            viewAppointment, newAppointment } = this.props;

        const branchesFilterOptions = this.parseBranches(branches.get('data').toJS());
        const dentists = practitioners.get('data').toJS();
        const dentistsFilterOptions = this.parseDentists(dentists);
        const proceduresOptions = this.parseProcedures(procedures.get('data').toJS());
        const appointmentDates = appointments.get('data').toJS();
        const activeAppointments = this.getAppointments();

        if (this.state.activeDisplay === 'list') {
            return (
                <div className="page-content">
                    <FABMultitple childMenu={this.state.fabChildMenu} newAppointment={newAppointment} />

                    <AppointmentModal procedures={proceduresOptions} dentists={dentistsFilterOptions}
                                      session={session}
                                      appointments={appointments}
                                      postAppointmentApi={postAppointmentApi}
                                      putAppointmentApi={putAppointmentApi}
                                      showNotification={showNotification}
                                      dateClicked={this.state.dateClicked}
                                      branches={branchesFilterOptions} />

                    <h3 className="page-title" style={{ float: 'left' }}>
                        Dashboard &nbsp; <small>Appointments</small>
                    </h3>

                    <h3 className="page-title" style={{ float: 'right' }}>
                        <i className={`fa fa-list calendar-toggle ${this.state.activeDisplay === 'list' ? 'active' : ''}`} onClick={this.handleChangeDisplayToList} />
                        <i className={`fa fa-calendar calendar-toggle ${this.state.activeDisplay === 'calendar' ? 'active' : ''}`} onClick={this.handleChangeDisplayToCalendar} />
                    </h3>

                    <div style={{ clear: 'both'}} />

                    <div className="row">
                        <div className="col-md-7 col-lg-7 col-sm-12 col-xs-12">
                            <div className="portlet light portlet-fit" style={{ minHeight: '585px', maxHeight: '585px'}} id="appointment_portlet">
                                <div className="portlet-title">
                                    <div className="caption">
                                        <i className=" icon-calendar font-blue" />
                                        <span className="caption-subject font-blue sbold uppercase">Appointments</span>
                                    </div>
                                </div>
                                <div className="portlet-body">
                                    <div className="row">
                                        <div className="col-md-12 col-sm-12">

                                            <Appointment {...this.props} cancelled={activeAppointments.statusCancelled}
                                                         pending={activeAppointments.statusPending}
                                                         completed={activeAppointments.statusCompleted}
                                                         viewAppointment={viewAppointment}
                                                         appointments={activeAppointments.appointments} />

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-5 col-lg-5 col-sm-12 col-xs-12">
                            <div className="portlet light portlet-fit" style={{ minHeight: '585px', maxHeight: '585px',overflowY : 'scroll'}}>
                                <div className="portlet-title">
                                    <div className="caption">
                                        <i className="icon-flag font-blue" />
                                        <span className="caption-subject font-blue sbold uppercase">Filters</span>
                                    </div>
                                </div>

                                <div className="portlet-body">
                                    <div className="row ">
                                        <div className="col-md-12 col-sm-12">
                                            <div id="external-events">

                                                <div className="row">
                                                    <div className="col-md-6 col-xs-12 col-sm-12">
                                                        <BootstrapSelect id="filter_branch" label=""
                                                                         help="Select clinic branch..."
                                                                         val={this.state.branch}
                                                                         onChange={this.handleFilterBranch}
                                                                         options={branchesFilterOptions} />
                                                    </div>

                                                    <div className="col-md-6 col-xs-12 col-sm-12">
                                                        <BootstrapSelect id="filter_dentists" label=""
                                                                         help="Select dentist..."
                                                                         val={this.state.dentist}
                                                                         onChange={this.handleFilterDentist}
                                                                         options={dentistsFilterOptions} />
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <br/><br/><br/>

                                        <Calendar appointmentDates={Object.keys(appointmentDates)}
                                                  selectedADate={this.props.selectedADate}
                                                  onDayClick={this.handleCalendarDayClick}
                                                  onChangeMonth={this.handleChangeMonth} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

        return (
            <div className="page-content">
                <FABMultitple childMenu={this.state.fabChildMenu} newAppointment={newAppointment} />
                <AppointmentModal procedures={proceduresOptions} dentists={dentistsFilterOptions}
                                  session={session}
                                  appointments={appointments}
                                  postAppointmentApi={postAppointmentApi}
                                  putAppointmentApi={putAppointmentApi}
                                  showNotification={showNotification}
                                  branches={branchesFilterOptions} />

                <h3 className="page-title" style={{ float: 'left' }}>
                    Dashboard &nbsp; <small>Appointments</small>
                </h3>

                <h3 className="page-title" style={{ float: 'right' }}>
                    <i className={`fa fa-list calendar-toggle ${this.state.activeDisplay === 'list' ? 'active' : ''}`} onClick={this.handleChangeDisplayToList} />
                    <i className={`fa fa-calendar calendar-toggle ${this.state.activeDisplay === 'calendar' ? 'active' : ''}`} onClick={this.handleChangeDisplayToCalendar} />
                </h3>

                <div style={{ clear: 'both'}} />

                <div className="row">
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                        <div className="portlet light portlet-fit">
                            <div className="portlet-title">
                                <div className="caption">
                                    <i className="icon-flag font-blue" />
                                    <span className="caption-subject font-blue sbold uppercase">Scheduler</span>
                                </div>
                            </div>

                            <div className="portlet-body">
                                <div className="row ">
                                    <div className="col-md-12 col-sm-12">
                                        <Scheduler dentists={dentists} appointments={appointmentDates} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }
}

const mapStateToProps = (state) => ({
    appointments: state.appointments,
    branches: state.branches,
    practitioners: state.practitioners,
    procedures: state.procedures,
    session: state.session
});

export default connect(mapStateToProps, {
    selectedADate,
    getAppointmentsApi,
    getBranchesApi,
    getProceduresApi,
    getPractitionersApi,
    viewAppointment,
    newAppointment,
    postAppointmentApi,
    putAppointmentApi,
    putAppointmentSuccess
})(Home);


/** WEBPACK FOOTER **
 ** ./src/containers/Home/index.js
 **/